import React, { useRef } from "react";

const ExperienceCard = ({
  image,
  title,
  subTitle,
  ctaText,
  ctaLink,
  history,
  vistTitle,
}) => {
  const onClick = () => {
    history.push(ctaLink);
    sessionStorage.setItem("scrollComponentId", vistTitle);
  };
  return (
    <div
      className="experience-card-wrapper"
      style={{
        backgroundImage: `url(
        ${image}?h=515&w=930)`,
      }}
    >
      <div className="linear-gradient"></div>
      <div className="experience-card-text-wrapper">
        <h2>{title}</h2>
        <p>{subTitle}</p>
        <button type="button" className="discoverButton" onClick={onClick}>{ctaText}</button>
      </div>
    </div>
  );
};

export default ExperienceCard;
